import React, { useContext } from "react";
import { Form } from "antd";
import { TimePicker } from "../../components/antOverrides";
import moment from "moment";
import { getFormItemLabel, getFormItemVaidation } from "../util/helpers";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";

import RestrictedContext from "../util/RestrictedContext";

const TimeFromMidnightItem = (props) => {
  const TimePickerComponent = ({
    value,
    onChange,
    disabled,
    disabledDate,
    minuteStep,
  }) => {
    const onHourChange = (time, timeString) => {
      var mmt = moment(time);
      var mmtMidnight = mmt.clone().startOf("day");
      var diffMinutes = mmt.diff(mmtMidnight, "minutes");
      onChange(time ? diffMinutes : null);
    };

    const restricted = useContext(RestrictedContext);
    const format = "HH:mm";

    return (
      <TimePicker
        disabled={disabled || !restricted["hasWritePermission"]}
        value={
          value ? moment().startOf("day").add(value, "minutes") : undefined
        }
        format={format}
        onChange={onHourChange}
        inputReadOnly={false}
        minuteStep={minuteStep}
      />
    );
  };
  const {
    name,
    required,
    category,
    dynamicFieldName,
    disabled,
    hideLabel,
    disabledDate,
    minuteStep,
  } = props;
  const intl = useIntl();
  const label = hideLabel
    ? null
    : getFormItemLabel(intl, category, name, dynamicFieldName);
  const arr = [];
  if (required) {
    arr.push("required");
  }
  const rules = getFormItemVaidation(intl, label, arr);
  const restricted = useContext(RestrictedContext);

  return (
    <Form.Item label={hideLabel ? null : label} name={name} rules={rules}>
      <TimePickerComponent
        disabled={disabled || !restricted["hasWritePermission"]}
        disabledDate={disabledDate}
        minuteStep={minuteStep}
      />
    </Form.Item>
  );
};

TimeFromMidnightItem.propTypes = {
  name: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  required: PropTypes.bool,
  category: PropTypes.string,
};

export default TimeFromMidnightItem;
